export enum ACTFLLevel {
	NOVICE_LOW = "N.L",
	NOVICE_MID = "N.M",
	NOVICE_HIGH = "N.H",
	INTERMEDIATE_LOW = "I.L",
	INTERMEDIATE_MID = "I.M",
	INTERMEDIATE_HIGH = "I.H",
	ADVANCED_LOW = "A.L",
	ADVANCED_MID = "A.M",
	ADVANCED_HIGH = "A.H",
	SUPERIOR = "S"
}

export enum CEFRLLevel {
	BREAKTHROUGH = "A1",
	WAYSTAGE = "A2",
	THRESHOLD_ONE = "B1.1",
	THRESHOLD_TWO = "B1.2",
	VANTAGE_ONE = "B2.1",
	VANTAGE_TWO = "B2.2",
	PROFICIENCY = "C1",
	MASTERY = "C2",
	UNDEFINED = "UNDEFINED"
}

export enum TestArea {
	SPEAKING = "SPEAKING",
	LISTENING = "LISTENING",
	WRITING = "WRITING",
	READING = "READING"
}